import { render } from "./Rueckblick.vue?vue&type=template&id=87994d28"
import script from "./Rueckblick.vue?vue&type=script&lang=js"
export * from "./Rueckblick.vue?vue&type=script&lang=js"

import "./Rueckblick.vue?vue&type=style&index=0&id=87994d28&lang=scss"

import exportComponent from "C:\\Users\\Alexander\\Documents\\Hompage TT Tools\\TT Homapge Files\\Webseite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__